import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Delete a component
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestDeleteComponent = packet => {
  return {
    type: 'REQUEST_DELETE_COMPONENT',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveDeleteComponentSuccess = data => ({
  type: 'RECEIVE_DELETE_COMPONENT_SUCCESS',
  data
})

export const receiveDeleteComponentFail = data => ({
  type: 'RECEIVE_DELETE_COMPONENT_FAIL',
  data
})

export const tryToDeleteComponent = packet => (dispatch, getState) => {

  dispatch(requestDeleteComponent(packet));

  let headers = {
    "Content-Type": "application/json"
  }
  


  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;  

  return fetch('/api/components/' + packet.id, {
      method: 'delete',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(push('/workbench/' + packet.scope));
      dispatch(receiveDeleteComponentSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveDeleteComponentFail({errors:e, lastSubmit: packet}));
    })
}
